var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"component":_vm.$options.name}},[_c('div',{attrs:{"data-shorthand":"https://stories.rostrum.agency/comprehensive-conversations-main-report-2024"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }